import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import '../styles/Login.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

function ForgotPasswordEmail() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Email adresi gerekli');
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await fetch(`${API_URL}/password-reset/email/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSent(true);
        toast.success('Şifre sıfırlama linki gönderildi!');
      } else {
        toast.error(data.detail || 'Bir hata oluştu');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Sunucuya bağlanılamadı');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <div className="login-logo">📧</div>
            <h1>Email Gönderildi</h1>
          </div>
          
          <div className="success-message">
            <div className="success-icon">✅</div>
            <p>Şifre sıfırlama linki <strong>{email}</strong> adresine gönderildi.</p>
            <p className="info-text">Lütfen email kutunuzu kontrol edin.</p>
            <p className="info-text">Link 1 saat içinde geçerliliğini yitirecektir.</p>
            <p className="info-text">Email gelmediyse spam klasörünü kontrol edin.</p>
          </div>
          
          <div className="login-footer">
            <Link to="/login" className="back-link">← Giriş sayfasına dön</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="login-logo">🔐</div>
          <h1>Şifremi Unuttum</h1>
          <p>Email adresinizi girin, şifre sıfırlama linki gönderelim.</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Email Adresi</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ornek@email.com"
              required
              autoFocus
            />
          </div>
          
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Gönderiliyor...' : 'Sıfırlama Linki Gönder'}
          </button>
        </form>
        
        <div className="login-footer">
          <Link to="/login" className="back-link">← Giriş sayfasına dön</Link>
        </div>
      </div>

      <style>{`
        .success-message {
          text-align: center;
          padding: 20px 0;
        }
        .success-icon {
          font-size: 64px;
          margin-bottom: 20px;
        }
        .success-message p {
          color: #555;
          margin: 10px 0;
        }
        .info-text {
          font-size: 13px;
          color: #888 !important;
        }
        .back-link {
          color: #667eea;
          text-decoration: none;
          font-size: 14px;
        }
        .back-link:hover {
          text-decoration: underline;
        }
        .login-footer {
          text-align: center;
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #eee;
        }
      `}</style>
    </div>
  );
}

export default ForgotPasswordEmail;